import { Typography } from '@mui/material';
import { isString } from '@weft/utils';
import type { PropsWithChildren } from 'react';
import { AddItemButton } from './AddItemButton';

type CreatePlanSectionProps = PropsWithChildren<{
  id?: string;
  title?: string | React.ReactElement;
  hideCreateAnother?: boolean;
  onAddItem?: () => void;
}>;

export const CreatePlanSection: React.FC<CreatePlanSectionProps> = ({
  id,
  children,
  title,
  hideCreateAnother,
  onAddItem,
}) => {
  return (
    <section
      id={id}
      className="w-full space-y-12"
    >
      <div className="space-y-5">
        {isString(title) ? 
          <Typography
            fontSize={16}
            fontWeight={400}
            color='rgba(27,61,85,0.60)'
          >
            {title}
          </Typography> : title}
        {children}
      </div>
      {!hideCreateAnother && (
        <AddItemButton
          onClick={onAddItem}
        />
      )}
    </section>
  );
};
